import { singularize } from "../../Utilities/Utilities.ts";

interface request {
    total: number | undefined,
    applyiedFilter: boolean,
    filterred: number | undefined,
    name: string
}
export function TableSummary({ total, applyiedFilter, filterred, name }: request) {

    return (
        <div className="d-flex justify-content-between align-items-center mt-2 px-1 text-muted-theme" style={{ fontSize: '0.85rem' }}>
            <span>
                {
                    applyiedFilter ?
                        ((filterred == 0) ? `No ${singularize(name)}s match the selected filters` :
                            `Showing ${filterred ?? 0} ${singularize(name)}${filterred === 1 ? '' : 's'} matching filters`) :
                        `Showing ${filterred ?? 0} ${singularize(name)}${filterred === 1 ? '' : 's'}`
                }
            </span>
            <span>
                Total {singularize(name)}s in System: {total ?? 0}
            </span>
        </div>
    )
}

export default TableSummary;